function isOutOfBound(step: number): boolean {
	return getNumberOfSteps() < step
}

function getNumberOfSteps() {
	// return Object.keys(steps).length - 1
	return 5
}

export { isOutOfBound, getNumberOfSteps }
